export const forms = {
    PESQUISA_CAMPOS: 'PESQUISA_CAMPOS',
    NOVOATUALIZA: 'NOVOATUALIZA',
    PESQUISA_CATEGORIAS: 'PESQUISA_CATEGORIAS',
    PESQUISA_BASE_CATEGORIA: 'PESQUISA_BASE_CATEGORIA',
    REMOVECATEGORIA: 'REMOVECATEGORIA',
    NOVACATEGORIA: 'NOVACATEGORIA'
}